import { ButtonLink } from "@components/ui/Button";
import { CityCardFragment, Country, UserOrSupplier } from "@graphql/types";
import React, { FC, Fragment } from "react";

interface Props {
  city?: CityCardFragment | null;
  country?: Country | null;
  user?: UserOrSupplier;
  className?: string;
}

const PlanYourTripAd: FC<Props> = ({ country, city, user, className = "" }) => {
  if (user) {
    return (
      <div
        className={`bg-yellow-100 bg-opacity-70 rounded p-10 text-center ${className}`}
      >
        {(city?.name || country?.name) && (
          <>
            <h3 className="text-3xl font-semibold mb-6 border-b-2 pb-2 border-red-600 inline-block leading-snug">
              Plan your trip to {city?.name || country?.name} with{" "}
              {user.displayName}
            </h3>

            <p className="text-lg leading-snug mb-10">
              Chat with a local tour guide who can help organize your trip.
            </p>
          </>
        )}

        {!city?.name && !country?.name && (
          <>
            <h3 className="text-3xl font-semibold mb-6 border-b-2 pb-2 border-red-600 inline-block leading-snug">
              {"Plan your trip to GoWithGuide's destinations"}
            </h3>

            <p className="text-lg leading-snug mb-10">
              Browse our destinations, find a guide, and get help organizing
              your trip.
            </p>
          </>
        )}

        {country === undefined ? (
          <ButtonLink
            size="lg"
            className="px-10"
            href={"/destinations"}
            title="GoWithGuide-Get Started"
          >
            Get Started
          </ButtonLink>
        ) : (
          <ButtonLink
            variant="secondary"
            size="lg"
            className="px-20"
            title="GoWithGuide-Send a message"
            href={`${user.url}/message?utm_medium=post&utm_source=blog-cta`}
          >
            Send a Message
          </ButtonLink>
        )}
      </div>
    );
  }

  if (city) {
    return (
      <div className={`bg-yellow-100 rounded p-10 text-center ${className}`}>
        <h3 className="text-3xl font-semibold mb-6 border-b-2 pb-2 border-red-600 inline-block">
          Plan your trip to {city.name}
        </h3>
        <p className="text-lg leading-snug mb-10">
          Chat with a local tour guide who can help organize your trip.
        </p>

        <ButtonLink
          size="lg"
          className="px-10"
          title="GoWithGuide - Get Started"
          href={`${city.url}/guides?utm_medium=post&utm_source=blog-cta`}
        >
          Get Started
        </ButtonLink>
      </div>
    );
  }

  if (country) {
    return (
      <div className={`bg-yellow-100 rounded p-10 text-center ${className}`}>
        <h3 className="text-3xl font-semibold mb-6 border-b-2 pb-2 border-red-600 inline-block">
          Plan your trip to {country.name}
        </h3>
        <p className="text-lg leading-snug mb-10">
          Chat with a local tour guide who can help organize your trip.
        </p>

        <ButtonLink
          size="lg"
          className="px-10"
          title="GoWithGuide- Get Started"
          href={`${country.url}/guides?utm_medium=post&utm_source=blog-cta`}
        >
          Get Started
        </ButtonLink>
      </div>
    );
  }

  return <Fragment />;
};

export default PlanYourTripAd;
